import { useCallback } from "react";

import { useProductRoomFormModelContext } from "../../../../context";

export const useRoomMaxRoomNum = () => {
	const { viewModel, onSetViewModel } = useProductRoomFormModelContext();
	const { maxRoomNum } = viewModel;

	const onSetMaxRoomNum = useCallback(
		(input: number | undefined) => {
			onSetViewModel([{ key: "maxRoomNum", value: { ...maxRoomNum, value: input ?? 0 } }]);
		},
		[maxRoomNum, onSetViewModel],
	);

	const isEdited = maxRoomNum.isEdited;
	const hasError = Boolean(maxRoomNum.error);

	return {
		isEdited,
		hasError,

		maxRoomNum,
		onSetMaxRoomNum,
	};
};
